module.exports = "<nav class=about-nav__nav> <ul class=about-nav__nav-menu> <li class=\"col-md-4 <% if(page === 'about-me') { %> selected <% } %>\"> <a href=\"<%- baseLink %>about-me/\"> About the Agent</a> </li> <li class=\"col-md-4 <% if(page === 'about-the-team') { %> selected <% } %>\"> <a class=location-link href=\"<%- baseLink %>about-the-team/\">About the Team</a> </li> <li class=\"col-md-4 <% if(page === 'contact-us') { %> selected <% } %>\"> <a class=location-link href=\"<%- baseLink %>contact-us/\">Contact</a> </li> </ul> </nav> ";


//////////////////
// WEBPACK FOOTER
// ./templates/about-nav.html
// module id = 184
// module chunks = 0